
<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}  <br><a href="https://docs.justwash.asia/tutorial/machines" style="color: #007aff; font-size: 14px;   font-weight: 400;" target="_blank">View tutorial</a>
          </h3>
        </div>

        <div class="col text-right">
          <!-- <base-button type="primary" size="md" href="#/washing-mode">สั่งเปิด / ปิดด้วยมือ</base-button> -->
          <a class="btn btn-primary" type="button" href="#/washing-mode">สั่งเปิด / ปิดด้วยมือ</a>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <!-- <th class="text-center" style="font-size: 14px;">รหัสเครื่อง</th> -->
          <th class="text-center" style="font-size: 14px;">ชื่อเครื่อง</th>
          <!-- <th class="text-center" style="font-size: 14px;">จำนวนการใช้งาน</th> -->
          <!-- <th class="text-center" style="font-size: 14px;">รายได้ (ไม่รวมค่าบริการ) </th> -->
          <th class="text-center" style="font-size: 14px;">สถานะ</th>
          <th class="text-center" style="font-size: 14px;">สถิติ</th>
          <th class="text-center" style="font-size: 14px;">ตั้งค่า</th>
          <th></th>
        </template>

        <template slot-scope="{row}" >

          <td class="text-center" type="button"  data-toggle="modal" data-target="#exampleModal" v-on:click="d()" >
            {{row.name_desc}} <div style="font-size: 9px; color: #C0C0C0; text-align: left;">({{row.name}})</div>
          </td>
<!--           <td class="text-center">

            {{row.used}}
          </td>
          <td class="budget text-center">
            <b>{{row.profit}} บาท</b>
          </td>
 -->
          <td class="text-center">
            <badge class="badge-dot mr-4" :type="row.statusType">
              <i :class="`bg-${washingStatusCode(row.status, row.name)}`"></i>
              <!-- <span class="status">{{row.status}}</span> -->
              <span class="status">{{washingStatus(row.status, row.name)}}</span>
            </badge>
          </td>

          <td class="text-center">
            <a class="btn btn-outline-success" v-bind:href="'#/statistics/'+row.name">
              <i class="ni ni-chart-bar-32"></i>
            </a>
          </td>

          <td class="text-center">
            <a class="btn btn-outline-primary" v-bind:href="'#/setting/'+row.name">
              <i class="ni ni-settings"></i>
            </a>


<!--             <base-dropdown class="dropdown"
                           position="right">
              <a slot="title" class="btn btn-sm btn-primary text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" v-bind:href="'#/washing-mode/'+row.name">เปิดเครื่อง</a>
                <a class="dropdown-item" href="#">ปิดเครื่อง</a>
                <a class="dropdown-item" href="#/qrcode">QRCode</a>
                <a class="dropdown-item" v-bind:href="'#/setting/'+row.name">ตั้งค่า</a>
              </template>
            </base-dropdown> -->
          </td>
        </template>
      </base-table>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        ...
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <!-- <base-pagination total="30"></base-pagination> -->
    </div>

</div>

</template>

<script>
  import $ from "jquery";

  import * as firebase from 'firebase';

  import JwService from '../../service/justwash';
  import apiService from '../../service/api';

  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyCUaLVCX3LU7eQcHhgeY-sAsBhRqlZlieI",
    authDomain: "justwash-api.firebaseapp.com",
    databaseURL: "https://justwash-api.firebaseio.com",
    projectId: "justwash-api",
    storageBucket: "justwash-api.appspot.com",
    messagingSenderId: "1043115702649",
    appId: "1:1043115702649:web:17296f85b68c54a57817a8"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  var database = firebase.database()
  var deviceRef = database.ref('/devices')

  export default {
    name: 'washing-machine-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        modals : {
          modal0 :false
        },
        tableData: null,
        devices: {},
        status_changepass: false,
      }
    },
    methods: {
      washingStatus:function(status, name) {
        if (this.devices[name] == undefined && status == 'Washing') {
          return 'In Use/Offline';
          // statusType: 'danger';
        }
        if (this.devices[name] == undefined) {
          status = 'Offline';
          // statusType: 'danger';
        }
        if (status == 'Washing') {
          status = 'In Use';
        }
        // console.log(this.devices[name]);
        return status;
      },
      washingStatusCode:function(status, name) {
        var statusType = 'danger';
        if (this.devices[name] == undefined) {
          //status = 'Offline';
          statusType: 'danger';
        } else if (status == 'Washing') {
          // status = 'Washing';
           statusType = 'primary';
        } else {
          // status = '';
           statusType = 'success';
        }
        // console.log(this.devices[name]);
        return statusType;
      },
      d:function(){
       console.log('1');
      }
    },
  async  mounted() {
        apiService.check();

      // eslint-disable-next-line no-undef
       this.$isLoading(true)

      axios({
        method: 'post',
        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.WashingMachines',
        data: {},
        headers: {
          'Authorization' : 'Token '+localStorage.getItem('accessToken')
        }
      }).then((response) => {
        if (response.data.message.status == true) {
             this.$isLoading(false)
          deviceRef.on('value', (snapshot) => {
            this.devices = snapshot.val();
            this.tableData = response.data.message.data.data;
            // console.log( this.tableData);

            // for (var idx in this.devices) {
            //   console.log( this.devices[idx]);
            // }
            // console.log(this.tableData);
          })
          // console.log(this.devices);
        } else {
          this.$router.push('/login');
        }
      }).catch(error => {
        console.log(error);
        this.$router.push('/login');
      });
    }
  }
</script>
<style>
</style>
